"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "StyletronEngine", {
  enumerable: true,
  get: function () {
    return _styletronEngineAtomic.Client;
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _baseui.BaseProvider;
  }
});
exports.default = void 0;

var _baseui = require("baseui");

var _react = _interopRequireDefault(require("react"));

var _styletronReact = require("styletron-react");

var _theme = require("./theme");

var _styletronEngineAtomic = require("styletron-engine-atomic");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Wraps children in providers necessary for baseui
 */
const StyleProvider = ({
  children,
  styletronEngine,
  debugEngine,
  debugAfterHydration,
  theme = _theme.defaultTheme,
  overrides
}) => /*#__PURE__*/_react.default.createElement(_styletronReact.Provider, {
  value: styletronEngine,
  debug: debugEngine,
  debugAfterHydration: debugAfterHydration
}, /*#__PURE__*/_react.default.createElement(_baseui.BaseProvider, {
  theme: theme,
  overrides: overrides
}, children));

var _default = StyleProvider;
exports.default = _default;